import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=c9a7911e&scoped=true&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"
import style0 from "./carousel.scss?vue&type=style&index=0&id=c9a7911e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a7911e",
  null
  
)

export default component.exports